import { ariaGetControlledElement, ariaIs, ariaToggle } from '@vo/js/utils/aria'
import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock'

export default (function () {
    const toggles = document.querySelectorAll('[data-toggle-archive-filters]')

    toggles.forEach((toggle) => {
        toggle.addEventListener('click', () => {
            const target = ariaGetControlledElement(toggle)

            if (ariaIs('expanded', toggle)) {
                target.setAttribute('hidden', '')
                clearAllBodyScrollLocks()
            } else {
                target.removeAttribute('hidden')
                disableBodyScroll(target)
            }

            toggles.forEach((toggle) => {
                ariaToggle('expanded', toggle)
            })
        })
    })
})
